<h2 mat-dialog-title>{{ titleKey | translate }}</h2>
<mat-dialog-content>
  <div class="selector-container">
    <div class="step">
      <h4>{{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.SELECT_NAMESPACE' | translate }}</h4>
      <ai-namespace-selector (selected)="onNamespaceSelected($event)"></ai-namespace-selector>
    </div>

    @if (selectedNamespace()) {
      <div class="step">
        <h4>{{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.SELECT_ASSISTANT' | translate }}</h4>
        @if (assistantsLoading()) {
          <div class="loading-container">
            <glxy-loading-spinner></glxy-loading-spinner>
          </div>
        } @else if (assistants().length === 0) {
          <p class="empty-message">{{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.NO_ASSISTANTS' | translate }}</p>
        } @else {
          <glxy-form-field bottomSpacing="none" class="full-width">
            <mat-select (selectionChange)="onAssistantSelected($event.value)">
              @for (assistant of assistants(); track assistant.id) {
                <mat-option [value]="assistant">
                  {{ assistant | assistantName }}
                </mat-option>
              }
            </mat-select>
          </glxy-form-field>
        }
      </div>
    }

    @if (selectedAssistant()) {
      <div class="step">
        <h4>{{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.SELECT_CASES' | translate }}</h4>
        @if (testCasesLoading()) {
          <div class="loading-container">
            <glxy-loading-spinner></glxy-loading-spinner>
          </div>
        } @else if (testCases().length === 0) {
          <p class="empty-message">{{ noCasesKey | translate }}</p>
        } @else {
          <div class="test-case-list">
            <div class="select-all">
              <mat-checkbox [checked]="allSelected" (change)="toggleAllTestCases()">
                {{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.SELECT_ALL' | translate }} ({{ testCases().length }}
                {{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.AVAILABLE' | translate }})
              </mat-checkbox>
            </div>
            <mat-list>
              @for (testCase of testCases(); track testCase.id) {
                <mat-list-item class="test-case-item">
                  <mat-checkbox [(ngModel)]="testCase.selected">
                    <span class="test-case-name">{{ testCase.name }}</span>
                  </mat-checkbox>
                </mat-list-item>
              }
            </mat-list>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="selectedCount === 0">
    {{ 'AI_ASSISTANT.TESTING.SELECTOR_MODAL.ADD_CASES' | translate: { count: selectedCount } }}
  </button>
</mat-dialog-actions>
